
/*all items in navbar & sidebar so i don't have to re write it */
export const navItems = [
    {
        name:'Home',
        link:'/',
    },
    {
        name:'Products',
        link:'/products',
    },
    {
        name:'Checkout',
        link:'/checkout',
    },
]













